import Vue from 'vue';
import VueRouter from 'vue-router';
import Review from '../views/Review.vue';
import FeedbackForm from '../views/FeedbackForm.vue';
import ThankYou from '../views/ThankYou.vue';
import FeedbackSubmitted from '../views/FeedbackSubmitted.vue';
import Error from '../views/Error.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/review',
    name: 'review',
    component: Review,
  },
  {
    path: '/feedback-form',
    name: 'feedbackForm',
    component: FeedbackForm,
  },
  {
    path: '/thank-you',
    name: 'thankYou',
    component: ThankYou,
  },
  {
    path: '/feedback-submitted',
    name: 'feedbackSubmitted',
    component: FeedbackSubmitted,
  },
  {
    path: '/error',
    name: 'error',
    component: Error,
  },
  {
    path: '*',
    redirect: { name: 'error' },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
});

function hasQueryParams(route) {
  return !!Object.keys(route.query).length;
}

router.beforeEach((to, from, next) => {
  if (!hasQueryParams(to) && hasQueryParams(from)) {
    next({ name: to.name, query: from.query });
  } else {
    next();
  }
});

export default router;
